import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { BrowserRouter as Router, Route, Routes, NavLink } from 'react-router-dom';

import ProductHero from './modules/components/ProductHero';
import QuizApp from './QuizApp';
import CodingProjects from './CodingProjects';
import SpeciesSpotter from './SpeciesSpotter';

const Water = React.lazy(() => import('./Water'));
const WaterbodiesView = React.lazy(() => import('./WaterbodiesView'));
const WaterbodyView = React.lazy(() => import('./WaterbodyView'));
const WaterManagement = React.lazy(() => import('./WaterManagement'));

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://tylerlcampbell.com/">
        TylerLCampbell.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function App() {
  const navClass = ({ isActive }) =>
    isActive ? 'nav-link active' : 'nav-link';

  return (
    <Router>
      <Container
        maxWidth={false}
        disableGutters
        sx={{ backgroundColor: 'gray', width: '100%', minHeight: '100vh' }}
      >
        <style>
          {`
          body, html {
            margin: 0;
            padding: 0;
            height: 100%;
            background-color: gray;
            font-family: Arial, sans-serif;
          }

          h1, h2 {
            margin-top: 0;
            color: white;
          }

          p {
            color: white;
          }

          .nav-bar {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            background-color: #333;
            gap: 18px;
          }

          .nav-link {
            color: white;
            text-decoration: none;
          }

          .nav-link.active {
            font-weight: bold;
            border-bottom: 2px solid white;
          }

          button {
            cursor: pointer;
          }
          `}
        </style>

        <nav className="nav-bar">
          <NavLink to="/" className={navClass} end>
            Home
          </NavLink>

          <NavLink to="/codingProjects" className={navClass}>
            Coding Projects
          </NavLink>
        </nav>

        <React.Suspense fallback={<div style={{ padding: 40, color: 'white' }}>Loading...</div>}>
          <Routes>
            <Route path="/" element={<ProductHero />} />
            <Route path="/codingProjects" element={<CodingProjects />} />
            <Route path="/quiz" element={<QuizApp />} />
            <Route path="/speciesspotter" element={<SpeciesSpotter />} />
            <Route path="/watermanagement" element={<WaterManagement />} />
            <Route path="/waterbodies_view" element={<WaterbodiesView />} />
            <Route path="/waterbody_view/:id" element={<WaterbodyView />} />

            {/* Hidden direct URL for TRMNL */}
            <Route path="/water" element={<Water />} />
          </Routes>
        </React.Suspense>

        <Copyright />
      </Container>
    </Router>
  );
}
